/**
 * 基础配置
 */
import config from '../../conf/base.conf'

export default {
  // 请求地址
  BASE_URL: config.BASE_URL,

  // 成功返回码
  SUCCESS_CODE: 0,

  // 授权返回码
  AUTH_CODE: [401, 403],

  // 授权页面名称
  AUTH_PAGE_NAME: 'auth_page'
}
